import { probeApiUrl } from '../../domain/stream-url';

/**
 * Odjemalec za `/api/probe` — nadgradnja sheme HTTP → HTTPS (T4 §3.1).
 *
 * Preverjanje mora teči v Workerju: brskalnik HTTP zahtevek s HTTPS strani
 * blokira, preden bi ga lahko preizkusil. Sam torej ne more ugotoviti, da
 * HTTPS različica obstaja.
 *
 * Zakaj se izplača: preverjanje 2026-07-19 je pokazalo, da imata HTTPS tudi
 * Radio Aktual Dalmacija in Radio Aktual — prek preusmeritve na
 * `live.radio.si`. Brez tega bi šli obe skozi proxy po nepotrebnem.
 */

const PROBE_TIMEOUT_MS = 8_000;

export type ResolveHttps = (url: string) => Promise<string | null>;

interface ProbeResponse {
  https: boolean;
  url: string;
}

export function createSchemeProbe(base?: string): ResolveHttps {
  return async (url) => {
    if (!url.startsWith('http://')) return null;

    try {
      const response = await fetch(probeApiUrl(url, base), {
        signal: AbortSignal.timeout(PROBE_TIMEOUT_MS),
      });
      if (!response.ok) return null;

      const body = (await response.json()) as ProbeResponse;
      return body.https && body.url.startsWith('https://') ? body.url : null;
    } catch {
      // Sonda je izboljšava, ne pogoj. Ob neuspehu ostane pot prek proxyja,
      // ki za samo-HTTP postajo tako ali tako deluje.
      return null;
    }
  };
}
